export const Hero = () => {
    return (
        <section id="home" className="hero d-flex justify-content-center align-items-center">
            <div className="container text-center">
                <div className="hero-badge p-4 rounded-4 shadow-lg d-inline-block">
                    <h1 className="mb-3">Powering a Brighter Tomorrow with Solar Energy</h1>
                    <p className="mb-4">Clean, renewable, and sustainable energy solutions for homes and businesses.</p>
                    <a href="#contact" className="btn btn-warning btn-lg text-dark">Get a Free Quote</a>
                </div>
            </div>
        </section>
    )
}